import { encrypt } from '@common/oneclub/utils'

export const UDB_CONF = { baseURL: '/udb', appid: process.env.APPID, subappid: process.env.SUB_APPID, encrypt }
